import { Box, Dialog } from "@mui/material";
import { AssetMap } from "../../../components/common/maps";
import type { Accordion, Asset, Country, Sector } from "../../../types/deal";

type DealMapFullscreenDialogProps = {
  open: boolean;
  onClose: () => void;
  assets: Asset[];
  accordions: Accordion[];
  dealMapInfo: {
    sectors: Sector[];
    countries: Country[];
  };
  setMapFullscreenOpen: (open: boolean) => void;
};

export function DealMapFullscreenDialog({
  open,
  onClose,
  assets,
  accordions,
  dealMapInfo,
  setMapFullscreenOpen,
}: DealMapFullscreenDialogProps) {
  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <Box sx={{ position: "relative", height: "100vh", width: "100%" }}>
        {/* Force a full remount when opened so Google Map sizes correctly */}
        {open ? (
          <AssetMap
            key="deal-map-fullscreen"
            assets={assets}
            accordions={accordions}
            dealMapInfo={dealMapInfo}
            height="100vh"
            setMapFullscreenOpen={setMapFullscreenOpen}
            mapFullscreenOpen={open}
          />
        ) : null}
      </Box>
    </Dialog>
  );
}
